module.exports = __webpack_public_path__ + "static/img/pdf-export.d87b830.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/projectImg/pdf-export.png
// module id = ol7p
// module chunks = 1